import {SPECIAL_EVENTS} from 'common/report/constants';

export const SPECIAL_ORDER_EVENTS: Map<string, number> = new Map([[SPECIAL_EVENTS.SELECTED_STEP, 0]]);
